import { Tabs as T } from "./Tabs";
import { Menu } from "./Menu";
import { List } from "./List";
import { Panel } from "./Panel";

/**
 * Tabs: Generic Tabs component
 * NB: onClick Action of Tabs.Menu is handled internally. If you override this one by
 *     passing onClick prop, you will need to explicity pass the value of clicked Menu
 *     as default prop to Tabs.Tabs to actualy trigger the Tab Change action.
 */
export const Tabs = {
  Tabs: T,
  Menu,
  List,
  Panel,
};
